export default function getShortBadge(
  value: string | number,
  max: number = 99,
): string {
  return +value > max ? `${max}+` : value.toString();
}
